var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from './icon';
export var IconWarning = React.forwardRef(function (props, ref) { return (_jsxs(Icon, __assign({ viewBox: "0 0 24 24", ref: ref, "data-name": "IconWarning" }, props, { children: [_jsx("path", { fillOpacity: ".9", d: "M13.5 10h-3l.5 4h2l.5-4zM13.5 16.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z" }), _jsx("path", { fillOpacity: ".9", fillRule: "evenodd", d: "M13.648 4.632a2 2 0 00-3.296 0l-9.1 13.235C.342 19.194 1.292 21 2.902 21h18.198c1.61 0 2.56-1.806 1.648-3.133L13.648 4.632zM12 5.765L21.099 19H2.901L12 5.765z", clipRule: "evenodd" })] }))); });
IconWarning.displayName = 'IconWarning';
export default IconWarning;
